/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';
import { format, parseISO } from 'date-fns';

import { AutoApprovalDTO } from 'hooks/useAutoApproval';

import trashIcon from 'assets/img/trash-icon.svg';
import xIcon from 'assets/img/x-icon.svg';

import {
  Container,
  Title,
  TableHeader,
  TableRow,
  RowContainer,
  RemoveButtonWrapper,
} from './styles';

interface AutoApprovalListProps {
  title: string;
  data: AutoApprovalDTO[];
  type: 'active' | 'draft' | 'inactive';
  onRemovePress: (id: number) => void;
  onEditPress: (id: number) => void;
}

const AutoApprovalList: FC<AutoApprovalListProps> = ({
  title,
  data,
  type,
  onRemovePress,
  onEditPress,
}) => {
  return (
    <Container>
      <Title>{title}</Title>
      <TableHeader>
        <label>Nome</label>
        <label>Público</label>
        <label>Prazo inscrições</label>
        <label>Cursos</label>
      </TableHeader>

      {data.map((dataRow) => {
        const targetPublic =
          dataRow.tipo === 'CV'
            ? 'Calouros e veteranos'
            : dataRow.tipo === 'C'
            ? 'Calouros'
            : 'Veteranos';

        const coursesCounter = !dataRow.cursos?.length
          ? 'Nenhum curso selecionado'
          : dataRow.cursos?.length === 1
          ? '1 curso selecionado'
          : `${dataRow.cursos?.length} cursos selecionados`;

        const formatedDateFrom = format(
          parseISO(dataRow.prazoInicial),
          'dd/MM/yyyy',
        );

        const formatedDateTo = format(
          parseISO(dataRow.prazoFinal),
          'dd/MM/yyyy',
        );

        return (
          <RowContainer key={dataRow.id}>
            <TableRow>
              <label>{dataRow.nome}</label>
              <label>{targetPublic}</label>
              <label>{`${formatedDateFrom} - ${formatedDateTo}`}</label>
              <label>{coursesCounter}</label>
            </TableRow>

            <div className="table-row__options">
              <span role="presentation" onClick={() => onEditPress(dataRow.id)}>
                {type === 'active'
                  ? 'Ver detalhes'
                  : type === 'draft'
                  ? 'Continuar edição'
                  : 'Ativar'}
              </span>
              {type !== 'inactive' && (
                <RemoveButtonWrapper
                  type={type}
                  onClick={() => onRemovePress(dataRow.id)}
                >
                  <img
                    src={type === 'active' ? xIcon : trashIcon}
                    alt="Remover aprovação"
                  />
                  <span>{type === 'active' ? 'Desativar' : 'Apagar'}</span>
                </RemoveButtonWrapper>
              )}
            </div>
          </RowContainer>
        );
      })}
    </Container>
  );
};

export default AutoApprovalList;
